<section class="page-container">
    <div class="container-fluid ptCustom">
        <div class="my-2">
            <a [routerLink]="['/admin-portal/chamber/pending-ads']" class="text-white"><i class="fa-regular fa-angle-left"></i> back to all pending ads</a>
        </div>

        <div class="row">
            <div class="col-lg-8 col-md-8 my-2">
                <div class="card shadow-sm rounded-lg">
                    <div class="card-body p-4">
                        <div class="detailsContainer">
                            <div class="detailsHeader">
                                <h4>Member Advertisement</h4>
                                <div class="d-flex align-items-center justify-content-end" *ngIf="!ad.isClosed">
                                    <a (click)="CommonLibrary.downloadImageByUrl(ad.imageUrl,ad.memberCompany + '_Ad_' + CommonLibrary.formatDateIntoString(ad.submissionDate))" class="me-3"><i class="fa-regular fa-download"></i></a>
                                    <a href="javascript:void(0);" (click)="openEditModal()" *ngIf="!ad.isClosed"><i class="fa-regular fa-pencil"></i></a>
                                </div>
                            </div>
                            <div class="detailsSection">
                                <div class="row">
                                    <div class="col">
                                        <div class="detailsBlock introLetterContent">
                                            <div class="pendingNewsPhotoContainer">
                                                <img [src]="ad.imageUrl" alt="featured image" class="pendingNewsPhotoImg" />
                                            </div>
                                            <p>
                                                <span class="d-block fw-bold">Ad Url</span>
                                                {{ ad.url }}
                                            </p>
                                            <p>
                                                <span class="d-block fw-bold">Date to Run</span>
                                                {{ ad.runDate }}
                                            </p>
                                            <p>
                                                <span class="d-block fw-bold">End Date</span>
                                                {{ ad.endDate }}
                                            </p>
                                            <p>
                                                <span class="d-block fw-bold">Notes from Member</span>
                                                {{ ad.memberNotes }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-4 my-2">
                <div class="card shadow-sm rounded-lg">
                    <div class="card-body p-4">
                        <div class="detailsContainer">
                            <div class="detailsHeader justify-content-center">
                                <h4>Review Letter</h4>
                            </div>
                            <div class="detailsSection">
                                <div class="detailsBlock">
                                    <div class="dataLabel">
                                        <span>Member</span>
                                    </div>
                                    <div class="dataOutput">
                                        <span class="d-block">{{ ad.memberName }}</span>
                                        <small class="text-muted">{{ ad.memberCompany }}</small>
                                    </div>
                                </div>

                                <div class="detailsBlock">
                                    <div class="dataLabel">
                                        <span>Previous Ad Submissions</span>
                                    </div>
                                    <div class="dataOutput">
                                        <span class="d-block">{{ ad.numberOfSubmissions}} Total </span>
                                        <small *ngIf="ad.numberOfSubmissions > 0" class="text-muted fst-italic">last on {{CommonLibrary.formatDateIntoString(ad.mostRecentSubmission)//getDate(ad.mostRecentSubmission)}}</small>
                                    </div>
                                </div>
                                <div *ngIf="!ad.isClosed">
                                    <div class="mb-3">
                                        <input [(ngModel)]="ad.approverNotes" type="text" class="form-control" id="exampleNotes" placeholder="Notes">
                                    </div>
                                    <div class="mb-4">
                                        <a href="javascript:void(0);" (click)="UpdateStatus(1)" type="button" class="btn btn-add text-strong hvr-grow w-100"><i class="fa-solid fa-check"></i> approve ad</a>
                                    </div>
                                    <div class="text-center">
                                        <a href="javascript:void(0);" (click)="UpdateStatus(2)" class="text-white"><small>reject ad</small></a>
                                    </div>
                                </div>

                                <div *ngIf="ad.isClosed">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Status</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span class="d-block">{{ad.statusString}}</span>
                                        </div>
                                    </div>

                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Notes</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span class="d-block">{{ad.approverNotes}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
